import "./quillSetup"
import { FC } from "react"
import ReactQuill from "react-quill"

const modules = {
    toolbar: [
        ['link']
    ],
}

interface Props {
    value?: string,
    onChange?: ReactQuill.ReactQuillProps["onChange"],
}

const CustomTextAreaNosotros: FC<Props> = ({ value, onChange }) => {
    return (
        <ReactQuill value={value}
            theme="snow"
            modules={modules}
            onChange={onChange} />
    )
}

export default CustomTextAreaNosotros